import { useContext, useEffect, useState } from "react";
import ContextFlujos from "../Context/ContextFlujos";
import QuejasSugerencias from "../Ayuda/QuejasSugerencias";
import { Col, Container, Row } from "react-bootstrap";
import styles from '../Ayuda/QuejasSugerencias.module.css';

const Ayuda = () => {
  const { setSkyPlus, setSkyCelular, pais, setPais, setDTHSkyPlus } = useContext(ContextFlujos) as any;

  useEffect(() => {

    if (sessionStorage.getItem("flujos") === "Sky+") {
      setSkyPlus({estado:false});
      setPais("MEX");
      setDTHSkyPlus({ estado: false });

  }else{
    setPais(sessionStorage.getItem("pais"));
  }

    if (sessionStorage.getItem("flujos") ===  "DTH/SkyCelular" || sessionStorage.getItem("flujos") ===  "DTH/DTH/SkyCelular/Sky+") {
      setSkyCelular({estado:true});
    }

    if (sessionStorage.getItem("flujos") ===  "DTH/Sky+" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular/Sky+") {
      setDTHSkyPlus({estado:false});
    }

    if (sessionStorage.getItem("flujos") ===  "DTH" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular") {
      setDTHSkyPlus({estado:true});
    }
  }, []);    

  return (
    <>
        <Container className={styles.containerPagina}>
            <Row>
                <Col>
                    <h2  className={styles.tituloPagina}><span className="textoSpectrum">Ayuda</span></h2>                
                </Col>
            </Row>
            <Row >
                <Col>
                    <p className={styles.textoPagina}>Aquí podrás conseguir ayuda para solucionar dudas o fallas con tus servicios Sky contratados.</p>                
                </Col>
            </Row>
            <Row>
                <Col>
                    <h3 className={styles.subtituloPagina}>Quejas y sugerencias</h3>                
                </Col>
            </Row>     
            <Row>
                <Col>
                    <p className={styles.textoPagina}>Selecciona el campo que necesitas e ingresa una descripción detallada, para que uno de nuestros 
                        agentes pueda brindarte una solución.</p>                
                </Col>
            </Row>            

        </Container>

        <QuejasSugerencias/>
        
    </>
  );
};

export default Ayuda;
